import React from 'react';
import extractLabelFromStr from '~/components/page/Automation/v2/util/extractLabelFromStr';
import ActionLabel from './components/ActionLabel';

export type Props = {
  dataTestId?: string;
  /**
   * A string that might include both label + text or just text
   * E.g. [[A1]] Some text
   */
  label: string | React.ReactNode | null;

  /**
   * Changes component's size
   */
  size?: 'small' | 'base';

  /**
   * If the outside container is hovered or clicked
   */
  active?: boolean;
};

const RepresentationLabel: React.FCC<Props> = ({
  dataTestId,
  label,
  size = 'base',
  active = false,
  ...rest
}) => {
  if (!label) return null;

  if (typeof label !== 'string') return <>{label}</>;

  const res = extractLabelFromStr(label);

  return (
    <>
      {res?.label && (
        <ActionLabel
          data-testid={dataTestId}
          size={size}
          active={active}
          label={res.label}
          {...rest}
        />
      )}

      {res?.text}
    </>
  );
};

export default RepresentationLabel;
